import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryQuick from '@/pages/home/components/CategoryQuick';
import LatestSection from '@/pages/home/components/LatestSection';
import TopicShowcase from '@/pages/home/components/TopicShowcase';
import SectionHeading from '@/components/feature/SectionHeading';
import MovieGrid from '@/components/feature/MovieGrid';
import { getHotMovies, movies } from '@/lib/movieData';
import { mediaTypeLabels } from '@/types/movie';

export default function Home() {
  const hot = getHotMovies(12);
  const stats = [
    { value: `${movies.length}+`, label: '在库影视', icon: 'ri-film-line' },
    { value: `${movies.filter((m) => m.type === 'tv').length}+`, label: '热门剧集', icon: 'ri-tv-2-line' },
    { value: `${movies.filter((m) => m.type === 'variety').length}+`, label: '综艺节目', icon: 'ri-mic-line' },
    { value: '3', label: '精选专题', icon: 'ri-bookmark-3-line' },
  ];

  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryQuick />
      <LatestSection />

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <SectionHeading
          eyebrow="人气榜单"
          title="热门内容"
          description="根据站内热度综合排序，看看大家都在追什么。"
          moreLink="/category/movie"
          moreLabel="查看更多热门"
        />
        <MovieGrid movies={hot} showHeat columns={6} />
      </section>

      <TopicShowcase />

      {/* 网站简介 */}
      <section className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="relative overflow-hidden rounded-lg bg-primary-950 px-6 md:px-12 py-12 md:py-16">
          <div className="absolute -right-10 -top-10 w-56 h-56 rounded-full bg-accent-500/10" />
          <div className="absolute right-24 bottom-0 w-32 h-32 rounded-full bg-primary-500/20" />
          <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wider text-accent-400 uppercase">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
                关于久久热
              </span>
              <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-background-50 leading-tight">
                你的影视发现站
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-200/85 leading-relaxed max-w-xl">
                久久热持续整理最新电影、热门电视剧与综艺的资讯与推荐，用清晰的分类、便捷的筛选和用心的专题策划，帮你在海量内容里更快找到想看的那一部。
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Link to="/category/movie" className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-accent-500 text-accent-950 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-compass-3-line text-lg" />
                  开始探索
                </Link>
                <Link to="/about" className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50/10 border border-background-100/30 text-background-50 text-sm font-semibold hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap">
                  了解我们
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="p-5 rounded-lg bg-primary-900/70 border border-primary-800">
                  <span className="w-10 h-10 rounded-md bg-primary-800 flex items-center justify-center text-accent-400">
                    <i className={`${s.icon} text-xl`} />
                  </span>
                  <p className="mt-3 font-display text-2xl md:text-3xl font-bold text-background-50">{s.value}</p>
                  <p className="mt-1 text-xs text-background-200/70">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 类型索引，利于浏览与 SEO */}
      <section className="w-full px-4 md:px-8 pb-14 md:pb-20">
        <h2 className="font-display text-lg font-bold text-foreground-950">热门题材索引</h2>
        <div className="mt-4 flex flex-wrap gap-2">
          {['动作', '爱情', '剧情', '科幻', '悬疑', '喜剧', '犯罪', '冒险', '奇幻', '动画', '历史', '都市', '青春', '真人秀'].map((g) => (
            <Link
              key={g}
              to={`/category/movie?genre=${encodeURIComponent(g)}`}
              className="h-9 px-4 inline-flex items-center rounded-full bg-background-100 border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {g}
            </Link>
          ))}
          {(['movie', 'tv', 'variety'] as const).map((t) => (
            <Link
              key={t}
              to={`/category/${t}`}
              className="h-9 px-4 inline-flex items-center rounded-full bg-secondary-100 text-secondary-800 text-sm font-medium hover:bg-secondary-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              {mediaTypeLabels[t]}频道
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}